import React from "react";
import Layout from "../../../components/layouts/Layout";
import { getStoredTwoWaySmsEnabled } from "../smsAccess";

export const SmsAccessDenied = () => (
  <Layout>
    <div className="page">
      <div className="card radius-10">
        <div className="card-body">
          <p className="mb-0 text-muted">
            2-Way SMS is not enabled for your venue.
            <br />
            Please contact The Haylo team.
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

const SmsAccessGuard = ({ children }) => {
  if (!getStoredTwoWaySmsEnabled()) {
    return <SmsAccessDenied />;
  }

  return children;
};

export default SmsAccessGuard;
